import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { IncidentTypeService } from './services/incident-type.service';
import { Router } from '@angular/router';
import { IonModal, ViewWillEnter, LoadingController } from '@ionic/angular';
import { StorageService } from './services/storage.service';
import { WebsocketService } from './services/websocket.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit{
  public appPages = [
    { title: 'Incidents', url: '/incidents', icon: 'clipboard' },
    { title: 'Reports', url: '/reports', icon: 'document-text' },
    { title: 'Incident Map', url: '/map', icon: 'map' },
    { title: 'Incident Types', url: '/incident-types', icon: 'settings' },
  ];
  public labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  incidentTypes: any;
  user: any;
  @ViewChild(IonModal) modal!: IonModal;


  constructor(private incidentTypeService: IncidentTypeService, public router: Router, public storageService: StorageService, public websocketService: WebsocketService, public loadingCtrl: LoadingController) { }

  ngOnInit() {
    console.log(this.router);
    this.incidentTypeService.getIncidentTypesObserve().subscribe((result: any) => {
      this.incidentTypes = result;
      console.log("INCIDENT TYPES");
      console.log(this.incidentTypes);
    });
    this.storageService.user$.subscribe((result: any) => {
      this.user = result;
      console.log(this.user);
    });
  }

  isFormRoute() {
    if (this.router.url.match(/\/incident\/[0-9a-zA-Z]*\/form\/[0-9a-zA-Z]\/?/g)) {
      return true;
    }
    return false;
  }

  incidentTypeSelected(incidentType: any) {
    this.modal.dismiss();
    this.showLoading();
    this.incidentTypeService.createIncident(incidentType, this.user.userName).subscribe((result: any) => {
      this.router.navigate(['/incident/' + result._id]);
      this.dismissLoading();
    });
  }

  closeIncidentModal() {
    this.modal.dismiss();
  }


  async showLoading() {
    const loading = await this.loadingCtrl.create({
      cssClass: 'loading',
      spinner: 'circular',
      translucent: false,
      showBackdrop: true,
    });

    loading.present();
  }

  dismissLoading() {
    this.loadingCtrl.dismiss(); 
  }


}
